import { api } from '@/core/api/';

const BaseUrl = '/api/support';

export const getAeeConfigParams = async () => {
  return await api.get(`${BaseUrl}/aeeconfiguration`);
};

export const saveUpdateParam = async (param) => {
  return await api.post(`${BaseUrl}/updateeaeeparamconfig`, param);
};
